// api/services/campaigns.ts
import { fetchCustomerResource, handleRequest } from '@/api';
import type { Campaign } from '@/types';

interface CustomerRef {
    id: number;
}

interface CampaignPayload {
    campaign_name: string;
    customer_id: number;
    start_date: string;
    end_date: string;
}

interface CampaignUpdatePayload extends CampaignPayload {
    id: number;
}

interface CampaignOperationResponse {
    message: string;
    campaign_id: number;
}

export const getCampaignsForCustomer = (customer: CustomerRef, signal?: AbortSignal): Promise<Campaign[]> =>
    fetchCustomerResource<Campaign[]>('campaigns', customer.id, signal);

export const saveNewCampaign = (payload: CampaignPayload): Promise<CampaignOperationResponse> =>
    handleRequest<CampaignOperationResponse>('post', `/campaigns/`, payload, 'Campaign saved successfully!');

export const updateCampaign = (payload: CampaignUpdatePayload): Promise<CampaignOperationResponse> =>
    handleRequest<CampaignOperationResponse>('put', `/campaigns/${payload.id}`, payload, 'Campaign updated.');

export const checkCampaignArchive = (campaignId: number) =>
    handleRequest<{ can_archive: boolean; reason?: string; details?: Record<string, unknown> }>(
        'get',
        `/campaigns/${campaignId}/archive-check`
    );

export const archiveCampaign = (campaignId: number) =>
    handleRequest<CampaignOperationResponse>('post', `/campaigns/${campaignId}/archive`, {}, 'Campaign archived.');
